export default [
  {
    path: "/crisis-management",
    name: "CrisisManagement",
    component: () =>
      import("@/views/Page/CrisisManagement/CrisisManagement.vue"),
    meta: {
      title: "#Default# | CrisisManagement",
    },
  },
  {
    path: "/crisis-management/:id",
    name: "CrisisManagementDetails",
    component: () =>
      import(
        "@/views/Page/CrisisManagement/Details/CrisesManagemantDetails.vue"
      ),
    meta: {
      title: "#Default# | CrisisManagement",
    },
  },
];
